import { WEEKDAYS } from '../constants';

export function expandRecurringEvents(events) {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const horizon = new Date(today); horizon.setMonth(horizon.getMonth() + 6);
  const result = [];
  for (const ev of events) {
    if (!ev.recurring || !ev.date) { result.push(ev); continue; }
    const stepDays = (ev.recurringInterval || 1) * 7;
    const targetJsDays = (ev.recurringDays || [])
      .map(d => WEEKDAYS.find(w => w.value === d)?.jsDay)
      .filter(d => d !== undefined);
    const targets = targetJsDays.length ? targetJsDays : [null];
    for (const jsDay of targets) {
      let cur = new Date(ev.date + 'T00:00:00');
      if (jsDay !== null) {
        const diff = (jsDay - cur.getDay() + 7) % 7;
        cur.setDate(cur.getDate() + diff);
      }
      const endLimit = ev.recurringEndDate ? new Date(ev.recurringEndDate + 'T00:00:00') : horizon;
      const stop = endLimit < horizon ? endLimit : horizon;
      let count = 0;
      while (cur <= stop && count < 200) {
        const d = `${cur.getFullYear()}-${String(cur.getMonth()+1).padStart(2,'0')}-${String(cur.getDate()).padStart(2,'0')}`;
        if (!(ev.excludedDates || []).includes(d)) {
          const suffix = jsDay !== null ? `-${jsDay}` : '';
          result.push({
            ...ev,
            date: d,
            _key: `${ev.id}${suffix}-${d}`,
            signups: ev.occurrenceSignups?.[d] || [],
            declines: ev.occurrenceDeclines?.[d] || [],
            gamesPlayed: ev.occurrenceGamesPlayed?.[d] || {},
            gamesRefereed: ev.occurrenceGamesRefereed?.[d] || {},
            lineup: ev.occurrenceLineups?.[d] ?? null,
            lineupPublished: ev.occurrenceLineupPublished?.[d] ?? false,
          });
        }
        cur = new Date(cur); cur.setDate(cur.getDate() + stepDays); cur.setHours(0, 0, 0, 0); count++;
      }
    }
  }
  return result;
}
